import { BatchRequestDocument, GraphQLClient } from "graphql-request";
import PrettyError from "pretty-error";

const baseUrl = process.env.NEXT_PUBLIC_CMS_URL + "/graphql" || "";

const pe = new PrettyError();

const craft = async (
  queries: BatchRequestDocument[] = [],
  token = null,
  jwtToken = null
) => {
  // Determine the url
  let url: string = baseUrl || "";
  if (token) url = `${url}?token=${token}`;

  let Authorization = null;

  if (jwtToken) {
    Authorization = `JWT ${jwtToken}`;
  } else {
    Authorization = `Bearer ${process.env.NEXT_PUBLIC_GRAPHQL_TOKEN}`;
  }

  const client = new GraphQLClient(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization,
    },
    fetch,
  });

  try {
    const array = await client.batchRequests(queries);

    return array.map((r) => r.data);
  } catch (error: any) {
    console.log(pe.render(error));

    throw error;
  }
};

export default craft;
